// French strings for Mali deployment.
// Backend stores emergency_type as English keys ("Medical","Fire","Police","FAMA")
// for stability, but UI always displays the French label.

export const FR = {
  // App
  appName: "SOS MALI",
  appTagline: "Help. Anywhere. Anytime.",
  selectEmergencyHint: "Sélectionnez le type d'urgence",
  attachmentsHint: "Ajouter photo, vidéo ou audio",
  secureFooter: "Votre alerte sera envoyée en toute sécurité.",
  tapToSendNow: "Appuyez pour envoyer maintenant",
  tapToSendInstruction: "Appuyez pour envoyer l'alerte",
  positionDetected: "Position détectée",
  positionSearching: "Recherche du signal GPS…",
  navCarte: "Carte",
  liveMapTitle: "Carte en direct",
  liveMapSubtitle: "Votre position en temps réel",
  cancelArmed: "Annuler",
  continueCta: "Continuer",
  evidenceModalTitle: "Ajouter une preuve",
  evidenceModalHint: "Photo, vidéo ou audio (optionnel)",
  country: "Mali",

  // Nav
  navSos: "SOS",
  navContacts: "Contacts",
  navHistory: "Historique",
  navSettings: "Réglages",

  // Home
  emergencyHeader: "URGENCE · SOS",
  emergencyTagline: "Envoyez une alerte avec votre position en direct.",
  status: "État",
  statusReady: "Prêt",
  statusLocating: "Localisation",
  emergencyType: "Type d'urgence",
  sendAlertCta: "Envoyer l'alerte d'urgence",
  attachmentsTitle: "Preuves (optionnel)",
  description: "Description (optionnelle)",
  descriptionPlaceholder: "Que se passe-t-il ? Blessés ? Dangers ? Repères ?",
  chooseEmergency: "Choisir le type d'urgence",
  addPhotoVideoAudio: "Photo · Vidéo · Audio",
  attachHint: "Photo, vidéo ou enregistrement audio.",
  cancel: "Annuler",
  confirm: "Confirmer",
  done: "Terminé",
  notifyContactsTitle: "Prévenir aussi mes proches",
  notifyContactsSub: "Famille et amis ajoutés dans l'onglet Contacts",
  pressAndHold: "Maintenez 1 seconde pour démarrer l'alerte",
  hold: "Maintenir…",
  holdCta: "Maintenir 1 s",
  dispatching: "Envoi de l'alerte…",
  alertDispatched: "Alerte envoyée",
  failedSend: "Échec de l'envoi de l'alerte",
  waitingGps: "En attente du GPS. Activez la localisation.",

  // Map preview
  acquiringGps: "Recherche GPS…",
  locationBlocked: "Localisation bloquée",
  locationBlockedDetail: "Autorisez la localisation pour envoyer une position précise.",
  highAcc: "ÉLEVÉE",
  medAcc: "MOYENNE",
  lowAcc: "FAIBLE",
  refresh: "Actualiser",

  // GPS Permission Gate (blocking-state modal)
  gpsRequiredKicker: "Localisation requise",
  gpsBlockedTitle: "Activez la localisation",
  gpsBlockedBody: "SOS MALI a besoin de votre position pour envoyer une alerte précise aux secours. Sans GPS, les services d'urgence ne pourront pas vous trouver rapidement.",
  gpsUnavailableTitle: "GPS indisponible",
  gpsUnavailableBody: "Votre appareil ne reçoit pas de signal GPS. Activez la localisation et essayez à l'extérieur ou près d'une fenêtre.",
  gpsUnsupportedTitle: "GPS non pris en charge",
  gpsUnsupportedBody: "Ce navigateur ne prend pas en charge la géolocalisation. Ouvrez SOS MALI dans Chrome ou Safari pour envoyer une position précise.",
  gpsStepOsTitle: "Sur votre téléphone",
  gpsStepOsBody: "Réglages → Localisation → Activer. Sur Android, descendez le volet et activez « Localisation ». Sur iPhone, Réglages → Confidentialité → Service de localisation.",
  gpsStepBrowserTitle: "Dans le navigateur",
  gpsStepBrowserBody: "Tapez l'icône cadenas à côté de l'adresse → Autorisations → Localisation → Autoriser, puis Réessayer.",
  gpsLater: "Plus tard",
  gpsRetry: "Réessayer",
  gpsRetrying: "Vérification…",
  close: "Fermer",

  // Tutorial (animated walkthrough)
  tutorialKicker: "Tutoriel",
  tutorialTitle: "Comment envoyer une alerte",
  tutorialCtaTitle: "Voir comment ça marche",
  tutorialCtaSubtitle: "Tutoriel rapide · 13 sec",
  tutorialClose: "Fermer le tutoriel",
  tutorialStep: "Étape",
  tutorialStepOf: "sur",
  tutorialDuration: "~13 sec",
  tutorialPause: "Pause",
  tutorialPlay: "Lecture",
  tutorialReplay: "Rejouer",
  tutorialGotIt: "J'ai compris",
  tutorialStep1: "Appuyer et maintenir le bouton SOS",
  tutorialStep2: "Choisir le type d'urgence",
  tutorialStep3: "Ajouter une photo, vidéo ou audio (optionnel)",
  tutorialStep4: "Envoyer l'alerte",
  tutorialSendLabel: "Envoyer",
  tutorialSentPill: "Alerte envoyée",
  tutorialPhoto: "Photo",
  tutorialAudio: "Audio",
  tutorialVideo: "Vidéo",

  // Contacts
  contactsTitle: "CONTACTS",
  contactsKicker: "Confiance",
  contactsIntro: "Famille et amis prévenus en parallèle des secours.",
  addContact: "Ajouter un contact",
  fullName: "Nom complet",
  phonePh: "Téléphone (ex. +22370000000)",
  emailPh: "E-mail",
  relPh: "Relation (optionnel, ex. Mère)",
  saving: "Enregistrement…",
  add: "Ajouter",
  contactCount: (n) => `${n} contact${n === 1 ? "" : "s"}`,
  noContacts: "Aucun contact pour le moment. Ajoutez-en au moins un pour une réponse plus rapide.",
  contactAdded: "Contact ajouté",
  contactRemoved: "Contact supprimé",
  contactUpdated: "Contact mis à jour",
  editContact: "Modifier le contact",
  saveChanges: "Enregistrer",
  errLoadContacts: "Impossible de charger les contacts",
  errSaveContact: "Impossible d'enregistrer le contact",
  errUpdateContact: "Impossible de mettre à jour",
  errDeleteContact: "Impossible de supprimer",
  errNameReq: "Le nom est obligatoire",
  errPhoneOrEmail: "Téléphone ou e-mail requis",
  errInvalidEmail: "E-mail invalide",
  errInvalidPhone: "Numéro de téléphone invalide",

  // Announcements bell
  announcements: "Annonces",
  announcementsKicker: "Diffusion",
  announcementsEmpty: "Aucune annonce pour le moment.",
  announcementMarkAllRead: "Tout marquer comme lu",
  unreadAnnouncement: "Non lu",
  receivedAt: "Reçu",

  // History
  historyTitle: "HISTORIQUE",
  historyKicker: "Journal",
  historyIntro: "Toutes les alertes envoyées et leurs résultats.",
  records: (n) => `${n} enregistrement${n === 1 ? "" : "s"}`,
  noAlerts: "Aucune alerte pour le moment.",
  channels: (n) => `${n} canal${n === 1 ? "" : "x"}`,
  sentLabel: "envoyés",
  failedLabel: "échoués",
  loading: "Chargement…",

  // Settings
  settingsTitle: "RÉGLAGES",
  settingsKicker: "Configuration",
  settingsIntro: "Numéros officiels pré-remplis. Premier destinataire à chaque alerte selon le type.",
  dispatcherPhone: "Téléphone du dispatcher",
  dispatcherEmail: "E-mail du dispatcher",
  defaultsBadge: "Numéros verts Mali",
  resetDefaults: "Restaurer les valeurs par défaut",
  defaultsRestored: "Valeurs par défaut restaurées",
  dispatcherFor: "Dispatcher · ",
  phoneShort: "Téléphone",
  emailShort: "E-mail",
  save: "Enregistrer",
  settingsSaved: "Réglages enregistrés",
  errSaveSettings: "Impossible d'enregistrer",
  apiInfo: (
    <>Pour activer l&apos;envoi réel de SMS et e-mails, ajoutez vos clés{" "}
      <span className="font-bold text-rescue-ink">Twilio</span> et{" "}
      <span className="font-bold text-rescue-ink">Resend</span> dans le fichier{" "}
      <span className="font-mono">.env</span> du backend. En attendant, chaque alerte est enregistrée et accessible via un lien à partager.
    </>
  ),

  // Result modal
  statusDelivered: "Alerte transmise",
  statusPartial: "Transmission partielle",
  statusInAppOnly: "Enregistrée dans l'app",
  type: "Type",
  deliveryReport: "Rapport d'envoi",
  openMap: "Ouvrir la carte",
  shareLink: "Lien à partager",
  inAppLog: "Journal interne",
  channelSms: "SMS",
  channelEmail: "E-mail",

  // Share page
  liveAlert: "Alerte d'urgence en direct",
  back: "Retour",
  alertNotFound: "Alerte introuvable",
  openPreciseLocation: "Ouvrir la position précise",
  copyShareLink: "Copier le lien",
  linkCopied: "Lien copié",
  copyFailed: "Impossible de copier",

  // Status pill labels
  pill: {
    delivered: "transmise",
    partial: "partielle",
    in_app_only: "interne",
    dispatching: "en cours",
  },

  // Delivery status
  delivery: {
    sent: "envoyé",
    skipped: "ignoré",
    failed: "échoué",
    pending: "en attente",
  },

  // Offline SOS
  offlineTitle: "SOS hors-ligne · SMS direct",
  offlineIntro: "Aucun internet ? Envoyez l'alerte par SMS via le réseau cellulaire. Tapez sur un destinataire — votre app SMS s'ouvre avec le message déjà rempli.",
  offlineNoRecipients: "Aucun destinataire configuré. Ajoutez un dispatcher dans Réglages ou un contact.",
  sendSmsTo: "SMS à",
  dispatcher: "Dispatcher",
  smsBodyFallback: "Aucun détail supplémentaire",
  emergencyShort: "URGENCE",
  helpNeeded: "Aide demandée",
  positionLabel: "Position",
  mapLabel: "Carte",
  sentVia: "Envoyé via SOS MALI",

  // Silent / panic mode
  silentTitle: "Mode silencieux",
  silentSubtitle: "Anti-violence · pour victimes en danger",
  silentDesc: "Aucune confirmation visible à l'écran. Aucun son. Une vibration courte uniquement. L'alerte reste envoyée et visible dans l'Historique.",
  silentOn: "Activé",
  silentOff: "Désactivé",
  silentBadge: "SILENCIEUX",

  // Voice recording
  recordVoice: "Enregistrer la voix",
  stopRecording: "Arrêter",
  transcribing: "Transcription…",
  voiceFailed: "Échec de la transcription vocale",
  voiceUnsupported: "L'enregistrement vocal n'est pas supporté ici",

  // Broadcast
  broadcastTitle: "Alerte de zone",
  broadcastDismiss: "Compris",

  // Language
  language: "Langue",
  langFR: "Français",
  langEN: "Anglais",

  // Onboarding gate
  onboardingTitle: "BIENVENUE",
  onboardingIntro: "Avant de pouvoir envoyer des alertes, identifiez-vous avec votre numéro de téléphone. Il sera utilisé uniquement pour la traçabilité des alertes.",
  onboardingLabel: "Votre numéro de téléphone",
  onboardingWarning: "Toute fausse alerte peut conduire à la suspension de votre numéro par les autorités. Utilisez ce service de manière responsable.",
  onboardingShort: "Numéro trop court",
  onboardingFailed: "Échec de l'enregistrement",
  onboardingSaving: "Enregistrement…",
  onboardingContinue: "Continuer",
  onboardingFooter: "Vos coordonnées GPS et votre numéro sont stockés de manière sécurisée et accessibles uniquement aux administrateurs et services d'urgence.",

  // Multi-type emergency
  multiTypeHint: "Vous pouvez sélectionner plusieurs types (ex. accident grave : Médical + Police).",
  noTypeSelected: "Sélectionnez au moins un type d'urgence",

  // Theme
  themeLabel: "Thème",
  themeLight: "Clair",
  themeDark: "Sombre",
  themeSystem: "Auto",

  // Intervention / Agency
  intervention: "Intervention",
  interventionPending: "En attente d'agence",
  interventionStatus: {
    dispatched: "Reçue",
    acknowledged: "Acceptée",
    en_route: "En route",
    on_scene: "Sur place",
    closed: "Clôturée",
    cancelled: "Annulée",
  },
  agencyHandling: "Prise en charge par",
  noAgencyYet: "Aucune agence n'a encore pris en charge cette alerte.",

  // Iter93 — Planification tab (Phase 1: workspace shell, no persisted
  // data yet — keys used by components/planification/*).
  planification: "Stratégie",
  planificationIndependentNote: "Espace de travail indépendant de la carte des alertes en direct",
  planificationDrawingTools: "Outils de dessin",
  planificationGeoLayers: "Couches géographiques",
  planificationSavedProjects: "Projets enregistrés",
  planificationComingSoon: "Disponible dans une prochaine version",
  planificationToolPan: "Déplacer",
  planificationToolZoomIn: "Zoom avant",
  planificationToolZoomOut: "Zoom arrière",
  planificationToolPolygon: "Dessiner un polygone",
  planificationToolLine: "Dessiner une ligne",
  planificationToolMeasureDistance: "Mesurer une distance",
  planificationToolMeasureArea: "Mesurer une surface",
  planificationToolAnnotation: "Ajouter une annotation",
  planificationToolTerrain: "Relief / élévation",
  planificationAccessDenied: "Accès réservé aux administrateurs.",
  // Phase 2B — drawing/measure tools, validation messages, mode-switch confirm.
  planificationCancelDrawing: "Annuler le dessin",
  planificationClosePolygon: "Fermer le polygone",
  planificationFinishLine: "Terminer la ligne",
  planificationTotalDistance: "Distance totale",
  planificationSegmentDistance: "Distance du segment",
  planificationArea: "Superficie",
  planificationLength: "Longueur",
  planificationVertex: "Sommet",
  planificationEditGeometry: "Modifier la géométrie",
  planificationPanMap: "Déplacer la carte",
  planificationSwitchToolConfirmTitle: "Dessin non terminé",
  planificationSwitchToolConfirmMessage: "Changer d'outil annulera le dessin en cours (non enregistré). Continuer ?",
  planificationSwitchToolConfirmOk: "Confirmer",
  planificationSwitchToolConfirmCancel: "Annuler",
  planificationInvalidPolygon: "Polygone invalide",
  planificationInvalidGeometry: "Géométrie invalide",
  planificationErrorNotPolygonGeojson: "Ce n'est pas un polygone GeoJSON valide.",
  planificationErrorInvalidCoordinates: "Coordonnées invalides (hors limites).",
  planificationErrorRingNotClosed: "L'anneau du polygone n'est pas fermé.",
  planificationErrorTooFewVertices: "Le polygone a moins de trois sommets distincts.",
  planificationErrorDuplicateConsecutiveVertices: "Deux sommets consécutifs sont dupliqués.",
  planificationErrorDegenerateRing: "L'anneau est dégénéré (superficie nulle).",
  planificationErrorSelfIntersecting: "Le polygone s'auto-intersecte.",
  planificationErrorTangentContact: "Un sommet touche un bord du polygone sans le croiser (contact tangent).",
  planificationErrorTooFewPositions: "La ligne a moins de deux points valides.",
  planificationErrorNotLinestringGeojson: "Ce n'est pas une ligne GeoJSON valide.",

  // Phase 2C — annotations, selection/edition, undo/redo, object list,
  // unsaved-work protection (spec Phase 2C §4-§8).
  planificationAnnotationNewTitle: "Nouvelle annotation",
  planificationAnnotationEditTitle: "Modifier l'annotation",
  planificationAnnotationTitleField: "Titre",
  planificationAnnotationTitleRequired: "Le titre est obligatoire.",
  planificationDescriptionField: "Description",
  planificationColorField: "Couleur",
  planificationOpacityField: "Opacité",
  planificationNameField: "Nom",
  planificationSave: "Enregistrer",
  planificationCancelAction: "Annuler",
  planificationSelectAction: "Sélectionner",
  planificationEditAction: "Modifier",
  planificationDeleteAction: "Supprimer",
  planificationMoveAction: "Déplacer",
  planificationGpsCoordinates: "Coordonnées GPS",
  planificationGeoObjects: "Objets géographiques",
  planificationCenterOnMap: "Centrer sur la carte",
  planificationUndo: "Annuler la dernière action",
  planificationRedo: "Rétablir",
  planificationClearAllDrawings: "Effacer tous les dessins",
  planificationClearAllConfirmTitle: "Confirmation requise",
  planificationClearAllConfirmMessage: "Effacer tous les dessins de cette session ?",
  planificationDeleteConfirmTitle: "Supprimer cet objet ?",
  planificationDeleteConfirmMessage: "Supprimer cet objet géographique ? Cette action pourra être annulée avec la commande Annuler.",
  planificationUnsavedWork: "Travaux non enregistrés",
  planificationNoObjectsCreated: "Aucun objet créé",
  planificationUnsavedNavTitle: "Travaux non enregistrés",
  planificationUnsavedNavMessage: "Vous avez des dessins non enregistrés. Quitter cette page effacera votre travail. Continuer ?",
  planificationStayHere: "Rester sur Stratégie",
  planificationLeaveAndDiscard: "Quitter et abandonner les dessins",
  planificationTypePolygon: "Polygone",
  planificationTypeLine: "Ligne",
  planificationTypeAnnotation: "Annotation",
  planificationTypeMeasureDistance: "Mesure de distance",
  planificationTypeMeasureArea: "Mesure de surface",
  planificationProperties: "Propriétés",
  planificationNoSelection: "Aucun objet sélectionné.",
  planificationObjectDeleted: "Objet supprimé.",
  planificationAllDrawingsCleared: "Tous les dessins ont été effacés.",

  // Agency dashboard
  agencyAccess: "Espace agences",
  agencyLoginTitle: "CONNEXION AGENCE",
  agencyLoginSubtitle: "Réservé aux agences d'intervention (SAMU, Pompiers, Police, FAMA).",
  agencyEmail: "Adresse e-mail professionnelle",
  agencyPassword: "Mot de passe",
  agencyLoginCta: "Se connecter",
  agencyLogout: "Déconnexion",
  agencyDashboard: "TABLEAU AGENCE",
  agencyAlertsHere: "Alertes assignées à votre agence",
  agencyNoAlerts: "Aucune alerte pour le moment.",
  agencyUpdate: "Mettre à jour le statut",
  agencyAcknowledge: "Accepter",
  agencyEnRoute: "En route",
  agencyOnScene: "Sur place",
  agencyClose: "Clôturer",
  agencyNotePh: "Note opérationnelle (optionnelle)",
  agencyUpdated: "Statut mis à jour",
  agencyUpdateFailed: "Échec de la mise à jour",

  // Admin · Agencies tab
  adminAgenciesTab: "Agences",
  adminAgenciesIntro: "Créez et gérez les comptes des agences d'intervention.",
  adminAddAgency: "Ajouter une agence",
  adminAgencyName: "Nom de l'agence (ex. SAMU Bamako)",
  adminAgencyEmail: "E-mail",
  adminAgencyPassword: "Mot de passe initial",
  adminAgencyType: "Type d'urgence",
  adminAgencyCreate: "Créer le compte",
  adminAgencyDelete: "Supprimer",
  adminAgencyConfirmDelete: "Supprimer ce compte agence ? Cette action est irréversible.",
  adminAgencyCreated: "Compte agence créé",
  adminAgencyDeleted: "Compte agence supprimé",
  adminNoAgencies: "Aucun compte agence pour le moment.",
};

export const EMERGENCY_FR = {
  // New 8 official categories
  Securite:    { label: "Forces de Sécurité", subtitle: "Sécurité" },
  Violence:    { label: "Violence" },
  Accident:    { label: "Accident" },
  Medical:     { label: "Urgence Médicale" },
  Fire:        { label: "Incendie" },
  Flood:       { label: "Inondation" },
  Missing:     { label: "Enlèvement", subtitle: "Disparition" },
  Report:      { label: "Signalement", subtitle: "Activité suspecte" },
  // Legacy keys — kept so historical alerts in production still render with
  // a label in admin/agency dashboards. NOT shown in the citizen picker.
  Police:      { label: "Police" },
  FAMA:        { label: "FAMA" },
  Security:    { label: "Sécurité" },
  Kidnapping:  { label: "Enlèvement" },
  Terrorist:   { label: "Terrorisme" },
  Corruption:  { label: "Corruption" },
  Other:       { label: "Autre" },
};
